/**
 * Gift order option for the cart page and cart drawer.
 * Saves the gift flag and message as cart attributes so they reach the order.
 * Attribute keys come from the input names, defined in snippets/gift-order.liquid.
 */
class GiftOrder extends HTMLElement {
  constructor() {
    super();

    this.toggle = this.querySelector('[data-gift-toggle]');
    this.fields = this.querySelector('[data-gift-fields]');
    this.message = this.querySelector('[data-gift-message]');
    this.counter = this.querySelector('[data-gift-counter]');

    this.toggle.addEventListener('change', this.onToggle.bind(this));
    this.message.addEventListener('input', this.updateCounter.bind(this));
    this.message.addEventListener('input', FoxTheme.utils.debounce(this.saveMessage.bind(this), 500));
  }

  onToggle() {
    const isGift = this.toggle.checked;

    this.fields.hidden = !isGift;
    // Disabled fields are not submitted with the checkout form.
    this.message.disabled = !isGift;

    // Blank values remove the attributes from the cart.
    this.updateAttributes({
      [this.attributeKey(this.toggle)]: isGift ? this.toggle.value : '',
      [this.attributeKey(this.message)]: isGift ? this.message.value.trim() : '',
    });
  }

  saveMessage() {
    if (!this.toggle.checked) return;
    this.updateAttributes({ [this.attributeKey(this.message)]: this.message.value.trim() });
  }

  updateCounter() {
    this.counter.textContent = this.message.value.length;
  }

  attributeKey(input) {
    return input.name.match(/^attributes\[(.+)\]$/)[1];
  }

  updateAttributes(attributes) {
    const body = JSON.stringify({ attributes });
    fetch(`${FoxTheme.routes.cart_update_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body } }).catch((error) => {
      console.error('Error updating gift order:', error);
    });
  }
}
customElements.define('gift-order', GiftOrder);
